import React from 'react';
import './FrameBlock.css';

function FrameBlock({ block }) {
  const getBackgroundStyle = () => {
    if (block.styles.backgroundType === 'gradient') {
      return { background: block.styles.backgroundGradient };
    }
    return { backgroundColor: block.styles.backgroundColor };
  };

  const styles = {
    width: '100%',
    height: '100%',
    ...getBackgroundStyle(),
    borderRadius: `${block.styles.borderRadius}px`,
    border: block.styles.borderWidth 
      ? `${block.styles.borderWidth}px solid ${block.styles.borderColor}`
      : 'none',
  };

  return <div className="frame-block" style={styles} />;
}

export default FrameBlock;
